import { calculateInvoiceTotals } from "utils/invoiceCalculations";
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Add } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import PickDate from "components/DatePicker/DatePicker";
import TimelineItem from "components/Icon/TimelineItem";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import BillingModal from "components/displayModel/billingModel";
import { useMaterialUIController } from "context";
import dayjs from "dayjs";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import PageTitle from "examples/PageTitle/PageTitle";
import { useCallback, useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { appConstants } from "utils/appConstants";
import {
  convertToTitleCase,
  formatDateWithCurrentTimeForPickDate,
  getScreenRight,
  showResMsg,
  validateField,
} from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import {
  SaveCredit,
  UpdateInvoice,
  getCreditDetailsByID,
  getItemsForInvoice,
  getQuotationsForInvoice,
} from "utils/invoiceAPI";
import { getContactsForQuotation } from "utils/quotationAPI";
import useFeatureAccess from "utils/useFeatureAccess";
import { getFileType } from "utils/generic";
import { loadingAction } from "ReduxReducers/loadingReducer";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import { paymentTermsOptions } from "utils/generic";
import { getEmailAndTemplateForQuotation } from "utils/quotationAPI";
import { AllKeysHaveValue } from "utils/generic";
import EmailTemplateModal from "components/EmailModal/EmailTemplateModal";
import useTableStyles from "styles/customStyleItemTable";
import { memo } from "react";
import { getCurrencyValue } from "utils/generic";
import { calculateAmounts } from "utils/generic";
import { calculatePrice } from "utils/generic";
import { getCurrencyCode } from "utils/api";
import { formatCurrencyAUD } from "utils/formatCurrency";
import { UpdateCredit } from "utils/invoiceAPI";
import CreditNoteEditor from "./CreditNoteEditor";

const SCREEN_NAME = "Invoices";
let SCREEN_RIGHT;
const pdfStyle = {
  boxShadow: 24,
  p: 4,
  top: "50%",
  left: "50%",
  width: "90%",
  height: "90%x",
  position: "absolute",
  border: "2px solid #000",
  bgcolor: "background.paper",
  transform: "translate(-50%, -50%)",
};
const tableCardStyle = { width: "100%" };
let routePath = "/creditNote";
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
function handleApiResponse({
  isUpdate,
  values,
  setOpen,
  showResMsg,
  navigate,
  handleSoftDismisal,
  setShowBillingModal,
  dispatch,
  redirectToOutside,
  CreditID,
}) {
  const apiFunction = isUpdate ? UpdateCredit : SaveCredit;

  return apiFunction(
    values,
    (data) => {
      console.log("data", data);
      if (data?.Result_Status) {
        setOpen(false);
        showResMsg(data.Result_Message, 2000, data.Result_Status);
        let targetRoute;
        if (redirectToOutside === "redirectToItemWhenSave") {
          navigate(`/items/addItems?new=credit&id=${CreditID}`);
        } else {
          let targetRoute = "/creditNote";
          // let targetRoute = isUpdate ? '/creditNote' : '/creditNote/edit/' + data.Result_Output._id;
          // navigate(routePath);
          // let targetRoute = `/creditNote/edit/${data.Result_Output._id}`;
          navigate(targetRoute);
        }
        // if (isUpdate) {
        //   targetRoute = '/invoices';
        // } else {
        //   //when save api run below code will excute
        //   targetRoute = '/invoices/edit/' + data.Result_Output._id;

        // }
        // navigate(targetRoute);
      } else if (data.Result_Message === "ALREADY_EXIST_PO") {
        handleSoftDismisal();
      } else {
        if (data.Result_Output === "NO AVAILABLE CREDITS") {
          setShowBillingModal(true);
        }
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    },
    dispatch
  );
}

function AddCreditNote() {
  //Starts here change the pagination text Rows per page to Record per page
  let changePaginationText =
    document.getElementsByClassName("rdt_Pagination")[0];
  if (changePaginationText !== undefined) {
    changePaginationText.getElementsByTagName("span")[0].textContent =
      "Records Per Page";
  } //ends here change the pagination text Rows per page to Record per page
  const featureAccess = useFeatureAccess();
  const customStyles = useTableStyles();

  let navigate = useNavigate();
  let dispatch = useDispatch();
  const { id: CreditID } = useParams();
  const showAddNewCustomer = CreditID === undefined;
  let type = new URLSearchParams(window.location.search).get("type");
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [loginDetails, setLoginDetails] = useState(
    JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
  );
  const [token, setToken] = useState(sessionStorage.getItem("TOKEN"));
  const [invoiceNoErr, setInvoiceNoErr] = useState(false);
  const [contactNameErr, setContactNameErr] = useState(false);
  const [contactDetails, setContactDetails] = useState([]);
  const [quotationDetails, setQuotationDetails] = useState([]);
  const [screenName, setScreenName] = useState("Add New Credit Note");
  const [typeQuotation, setTypeQuotation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSendEmailBtn, setShowSendEmailBtn] = useState(false);

  const [showBillingModal, setShowBillingModal] = useState(false);
  const [itemsDetails, setItemsDetails] = useState([]);
  const [masterItemDetails, setMasterItemDetails] = useState([]);
  const [itemRowValues, setItemRowValues] = useState([
    {
      itemID: "",
      itemName: "",
      itemPrice: "",
      itemDescription: "",
      categoryCodeName: "",
      itemQuantity: "",
      gst: "",
      discountType: "None",
      discountValue: "",
      discountAmount: 0,
      totalItemPrice: 0,
    },
  ]);
  const [usedRetentionAmount, setUsedRetentionAmount] = useState(0);
  const [finalise, setFinalise] = useState(false);
  const [scheduleRetention, setScheduleRetention] = useState(false);
  const [retentionItemValues, setRetentionItemValues] = useState([]);
  const [getDocumentFileURL, setSetDocumentFileURL] = useState("");
  const [selectedFileType, setSelectedFileType] = useState("");
  const [showInvoicePaymentLink, setShowInvoicePaymentLink] = useState(false);
  //Used for Modal Email Template
  const [open, setOpen] = useState(false);
  const [templateValues, setTemplateValues] = useState({
    screenType: "Credit",
    userEmailAddress: "",
    customerEmailAddress: [],
    emailTemplate: "",
  });

  const [values, setValues] = useState({
    token: token,
    businessUserID: loginDetails?.businessUserID,
    creditID: undefined,
    userID: loginDetails?._id,
    creditNumber: "Auto Generated",
    // invoiceType: "Direct",
    contactID: "",
    quotationID: "",
    purchaseOrderNumber: "",
    creditDate: new Date(new Date() - new Date().getTimezoneOffset() * 60000),
    dueDate: new Date(new Date() - new Date().getTimezoneOffset() * 60000),
    dueUpto: "Same Day",
    // creditStatus: 'Unpaid',
    gstType: "Inclusive",
    totalAmount: 0,
    totalDiscountAmount: 0,
    totalGSTAmount: 0,
    finalAmount: 0,
    paymentInstruction: "",
    documentName: "",
    sendEmailFlag: false,
  });
  // const [file, setFile] = useState(null);
  const [quoDocuments, setDocuments] = useState([]);
  const [currencyCode, setCurrencyCode] = useState("");

  const itemRowValuesRef = useRef(itemRowValues);
  const savingRef = useRef(false);
  const saveIntentRef = useRef(false);
  const [saving, setSaving] = useState(false);
  const [savingAction, setSavingAction] = useState("");
  const retentionItemValuesRef = useRef(retentionItemValues);

  useEffect(() => {
    var element = document.getElementsByTagName("fieldset");
    let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
    var disabledval = document.querySelectorAll(".Mui-disabled");
    var dropicons = document.querySelectorAll(".MuiInputBase-root");
    for (let i = 0; i < element.length; i++) {
      element[i].style.borderColor = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < labelShrink.length; i++) {
      labelShrink[i].style.color = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < disabledval.length; i++) {
      var usevalue = disabledval[i].getElementsByTagName("input");

      if (usevalue.length > 0) {
        if (darkMode) {
          usevalue[0].style.setProperty(
            "-webkit-text-fill-color",
            "white",
            "important"
          );
        } else {
          usevalue[0].style.removeProperty("-webkit-text-fill-color");
        }
      }
    }

    for (let i = 0; i < dropicons.length; i++) {
      var svgicon = dropicons[i].getElementsByTagName("svg");
      if (svgicon.length > 0) {
        if (darkMode) {
          svgicon[0].setAttribute("style", "fill: white !important;");
        } else {
          svgicon[0].setAttribute("style", "fill:");
        }
      }
    }
  }, [itemRowValues]);

  useEffect(() => {
    if (
      JSON.stringify(itemRowValues) !== JSON.stringify(itemRowValuesRef.current)
    ) {
      itemRowValuesRef.current = itemRowValues;
      calculateDiscountAmount(itemRowValues);
    }
    const filtered = itemRowValues.filter(
      (item) => item.itemID !== "" && item.itemID !== undefined
    );
    if (filtered.length > 0) {
      setShowSendEmailBtn(
        filtered.every((row) => row.itemID && row.itemPrice && row.itemQuantity)
      );
    } else {
      setShowSendEmailBtn(false);
    }
  }, [itemRowValues]);

  // useEffect(() => {
  //   if (values.invoiceType === "Through Quotation" && values.quotationID) {
  //     setTypeQuotation(true);
  //   } else {
  //     setTypeQuotation(false);
  //   }
  // }, [values.invoiceType, values.quotationID])

  // useEffect(() => {
  //   const itemFromUrl = new URLSearchParams(window.location.search).get('item');
  //   //   console.log("itemFormUrl", itemFromUrl)
  //   if (itemFromUrl) {
  //     const selectedItem = masterItemDetails.find(item => item._id === itemFromUrl);
  //     console.log("selectedItem", selectedItem)
  //     if (selectedItem) {
  //       const newItemValue = { value: itemFromUrl };
  //       handleItemRow('', newItemValue, itemRowValues.length - 1);
  //       // const rowIndex = itemRowValues.findIndex(row => !row.value); // Example to find the first empty row
  //       // console.log("dsd", rowIndex)

  //       // if (rowIndex) {
  //       //   console.log("dsd", rowIndex)
  //       //   handleItemRow('', newItemValue, rowIndex); // Update the row with the correct index
  //       // } else {
  //       //   // Fallback or add a new row logic
  //       //   console.warn('No empty row found to update');
  //       // }
  //     }
  //   }
  // }, [masterItemDetails]);

  useEffect(() => {
    const paramValue = new URLSearchParams(window.location.search).get(
      "status"
    );

    // switch (paramValue) {
    //   case "debt":
    //     routePath = '/debts';
    //     break;
    //   default:
    //     routePath = '/invoices';
    //     break;
    // }
    const fetchData = async () => {
      try {
        setScreenName(
          CreditID
            ? type !== "clone"
              ? "Edit Credit Note"
              : "Clone Credit Note "
            : "Add New Credit Note"
        );
        setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));

        await Promise.all([
          getRight(),
          LoadInitialData(),
          fetchCurrencyValue(),
        ]);

        // setCurrencyCode(await getCurrencyValue());
        await FetchQuotationDetailsByID();
        // if (CreditID) {
        //   await FetchQuotationDetailsByID();
        // } else {
        //   dispatch(loadingAction(false));
        // }
        dispatch(loadingAction(false));
      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };
    fetchData();
  }, [dispatch, CreditID]);

  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
  }

  let fetchCurrencyValue = async () => {
    await getCurrencyCode(
      { businessUserID: values.businessUserID },
      (data) => {
        if (data.Result_Status) {
          setCurrencyCode(data.Result_Output);
        }
      },
      dispatch
    );
  };

  const LoadInitialData = async () => {
    try {
      const [customerList, quotationList] = await Promise.all([
        new Promise((resolve, reject) => {
          getContactsForQuotation(
            { businessUserID: values.businessUserID },
            resolve,
            dispatch
          );
        }),
        new Promise((resolve, reject) => {
          getQuotationsForInvoice(
            { businessUserID: values.businessUserID, creditID: CreditID },
            resolve,
            dispatch
          );
        }),
      ]);
      if (customerList.Result_Output.length > 0) {
        setContactDetails(customerList.Result_Output);
      }
      if (quotationList.Result_Status) {
        // console.log("setQuotationDetails", quotationList.Result_Output)
        setQuotationDetails(quotationList.Result_Output);
      }
    } catch (error) {
      console.error("Error getting Invoice Details: ", error.message);
    }
  };

  const FetchQuotationDetailsByID = async () => {
    try {
      const itemsPromise = new Promise((resolve, reject) => {
        getItemsForInvoice(
          values,
          (data) => {
            if (data.Result_Output.length > 0) {
              setItemsDetails(data.Result_Output);
              setMasterItemDetails(data.Result_Output);
              resolve();
            } else {
              reject(new Error("No items found for quotation"));
            }
          },
          dispatch
        );
      });
      let detailsPromise;
      if (CreditID) {
        values.creditID = CreditID;
        // Fetch quotation details
        detailsPromise = new Promise((resolve, reject) => {
          getCreditDetailsByID(
            values,
            (data) => {
              let result = data.Result_Output;
              // if (result[0].creditStatus === "Paid") {
              //   return navigate('/creditNote');
              // }
              // else
              if (result.length > 0 && result[0]) {
                console.log("result", result);
                setFinalise(result[0]?.emailSent > 0);
                setValues((prevValues) => ({ ...prevValues, ...result[0] }));
                if (result[0].items?.length > 0)
                  setItemRowValues(result[0].items);
                if (result[0].invoiceDocuments?.length > 0)
                  setDocuments(result[0].invoiceDocuments);

                // if (result[0].retentions?.length > 0) {
                //   setScheduleRetention(true);
                //   setRetentionItemValues(result[0].retentions);
                // }
                setShowInvoicePaymentLink(result[0].showPaymentSection);
              }
            },
            dispatch
          );
        });
      } else {
        dispatch(loadingAction(false));
      }
      // Wait for both promises to resolve
      await Promise.all([itemsPromise, detailsPromise]);
    } catch (error) {
      console.error("Error in FetchQuotationDetailsByID:", error);
      // Handle errors as needed
    }
  };

  // const FetchQuotationDetailsByID = (async () => {
  //   values.creditID = CreditID;
  //   try {
  //     const [itemsData, detailsData] = await Promise.all([
  //       new Promise((resolve, reject) => {
  //         getItemsForInvoice(values, resolve, dispatch);
  //       }),
  //       new Promise((resolve, reject) => {
  //         getInvoiceDetailsByID(values, resolve, dispatch);
  //       })
  //     ]);

  //     if (itemsData.Result_Output.length > 0) {
  //       setItemsDetails(itemsData.Result_Output);
  //       setMasterItemDetails(itemsData.Result_Output);
  //     }

  //     let result = detailsData.Result_Output;
  //     if (result[0].invoiceStatus === "Paid") {
  //       return navigate('/invoices');
  //     }
  //     else if (result.length > 0 && result[0]) {
  //       setFinalise(result[0]?.emailSent > 0);
  //       setValues(prevValues => ({ ...prevValues, ...result[0] }));
  //       if (result[0].items?.length > 0) setItemRowValues(result[0].items);
  //       if (result[0].invoiceDocuments?.length > 0) setDocuments(result[0].invoiceDocuments);
  //

  //       if (result[0].retentions?.length > 0) {
  //         setScheduleRetention(true);
  //         setRetentionItemValues(result[0].retentions);
  //       }
  //       setShowInvoicePaymentLink(result[0].showPaymentSection);
  //     }
  //   } catch (error) {
  //     console.error("Error in FetchQuotationDetailsByID:", error);
  //   }

  // }, [dispatch, CreditID]);

  const handleChangeApprovedQuotation = (name) => (event, newValue) => {
    if (newValue) {
      const selectedItem = quotationDetails.find(
        (quotation) => quotation._id === newValue.id
      );
      console.log("selsctItem", selectedItem);
      if (selectedItem) {
        setValues({
          ...values,
          [name]: selectedItem.quotationNumber,
          quotationID: newValue.id,

          contactID: selectedItem.contactID,
          gstType: selectedItem.gstType,
          finalAmount: selectedItem.finalAmount,
          paymentInstruction: selectedItem.paymentInstruction,
          purchaseOrderNumber: selectedItem.purchaseOrderNumber,
          totalAmount: selectedItem.totalAmount,
          totalDiscountAmount: selectedItem.totalDiscountAmount,
        });
        setItemRowValues(selectedItem.items);
        setDocuments(selectedItem.quotationDocuments);
      }
    } else {
      setValues({ ...values, [name]: "", quotationID: "" });
    }
  };
  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function endOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  function calculateDueUpto(paymentTerms, creditDate) {
    try {
      const currentDate = new Date(creditDate);

      switch (paymentTerms) {
        case "Same Day":
          return currentDate;
        case "7 Days":
          return addDays(currentDate, 7);

        case "14 Days":
          return addDays(currentDate, 14);

        case "30 Days":
          return addDays(currentDate, 30);

        case "14 Days End of Month":
          return addDays(endOfMonth(currentDate), 14);

        case "30 Days End of Month":
          return addDays(endOfMonth(currentDate), 30);

        default:
          throw new Error("Invalid payment term");
      }
    } catch (error) {
      console.error("calculateDueUpto Error", error);
    }
  }

  const handleValidUptoDate = (paymentTerms) => {
    try {
      const dueDate = calculateDueUpto(paymentTerms, values.creditDate);
      setValues((prevValues) => ({
        ...prevValues,
        dueDate: dueDate,
        dueUpto: paymentTerms,
      }));
    } catch (error) {
      console.error("handleValidUptoDate Error", error);
    }
  };
  const handleChangeCustomer = (name) => (event, newValue) => {
    if (newValue) {
      if (newValue.value === "add-new") {
        navigate("/contacts/addContact?new=invoice");
      } else {
        const paymentTerms =
          contactDetails.find((customer) => customer._id === newValue.value)
            .paymentTerms || "30 Days End of Month";
        handleValidUptoDate(paymentTerms);
        // setValues({ ...values, [name]: newValue.label, contactID: newValue.value });
        setValues((prevValues) => ({
          ...prevValues,
          [name]: newValue.label,
          contactID: newValue.value,
        }));
      }
    } else {
      setValues({ ...values, [name]: "", contactID: "" });
    }
  };
  const handleValidUpto = (name) => (event) => {
    if (name === "dueUpto") {
      handleValidUptoDate(event.target.value);
    }
  };
  //Handle Save or Update Quotation Function
  const handleChange = (name) => (event) => {
    let value = event.target.value;

    if (name === "totalDiscountAmount") {
      setValues((prev) => ({ ...prev, totalDiscountAmount: value }));

    }

    if (name === "gstType") {
      setValues((prev) => ({ ...prev, gstType: value }));
      handleCalculation(value);
    } else if (name === "contactID" && value === "add_new") {
      navigate("/contacts/addContact?new=invoice");
    } else if (
      name === "invoiceType" &&
      value === "Through Quotation" &&
      quotationDetails.length <= 0
    ) {
      swal({
        icon: "warning",
        text: "Please proceed with Direct Invoice Type.",
        title: "There is no Approved Quotation Available!",
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    } else if (name === "invoiceType" && value === "Direct") {
      if (values.quotationID) {
        ShowSwalWithButtons(
          `Are you sure, you want to change Invoice Type.`,
          `Changing Invoice Type to 'Direct' will clear all quotation-related fields. Are you sure you want to continue?`,
          "warning",
          darkMode,
          () => {
            setValues({
              ...values,
              [name]: event.target.value,
              quotationID: "",
              quotationNumber: "",
              contactID: "",
              gstType: "",
              finalAmount: "",
              paymentInstruction: "",
              purchaseOrderNumber: "",
              totalAmount: "",
              totalDiscountAmount: "",
            });
            setItemRowValues([]);
            setDocuments([]);
          }
        );
      } else setValues({ ...values, [name]: value, quotationID: "" });
    } else if (event.target.validity && event.target.validity.valid) {
      setValues({ ...values, [name]: value });
    } else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: value });
    }
  };
  const clearAllErrorMsg = () => {
    setContactNameErr(false);
    setInvoiceNoErr(false);
  };

  function identifyMissingItems(itemRowValues) {
    let missingItems = [];
    itemRowValues.forEach((row, index) => {
      if (!row.itemID || !row.itemPrice || !row.itemQuantity) {
        missingItems.push(index + 1);
      }
    });
    console.log("missingItems", missingItems);
    if (missingItems.length === 0) {
      return "All items are filled in.";
    }

    let missingItemsMessage =
      "Please fill in all of the following items before creating the invoice:\n";
    missingItems.forEach((itemIndex) => {
      missingItemsMessage += `Row ${itemIndex}: `;
      if (!itemRowValues[itemIndex - 1].itemID) {
        missingItemsMessage += "Item Name, ";
      }
      if (!itemRowValues[itemIndex - 1].itemPrice) {
        missingItemsMessage += "Item Price, ";
      }
      if (!itemRowValues[itemIndex - 1].itemQuantity) {
        missingItemsMessage += "Item Quantity, ";
      }
      // if (!itemRowValues[itemIndex - 1].gst) {
      //   missingItemsMessage += "GST% ";
      // }
      missingItemsMessage = missingItemsMessage.slice(0, -2); // Remove the last comma and space
      missingItemsMessage += "\n";
    });

    return missingItemsMessage;
  }
  const handleSaveInvoice = async (redirectToOutside = null, draft = saveIntentRef.current) => {
    saveIntentRef.current = draft;
    if (savingRef.current) return;
    clearAllErrorMsg();

    const updatedValues = { ...values, activityStatus: draft ? "Draft" : "Issued" };

    if (type) updatedValues.type = type;

    if (!updatedValues.creditDate || Number.isNaN(new Date(updatedValues.creditDate).getTime())) {
      return showResMsg("Enter a valid credit note date", 2000, false);
    }

    if (updatedValues.creditDate instanceof Date) {
      const day = updatedValues.creditDate;
      updatedValues.creditDate = `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, "0")}-${String(day.getDate()).padStart(2, "0")}`;
    }

    // ----- CONTACT VALIDATION -----
    if (!updatedValues.contactID) {
      validateField(updatedValues.contactID, setContactNameErr);
      return;
    }

    // ----- CREDIT ID -----
    updatedValues.creditID = CreditID ?? updatedValues.creditID;
    console.log("itemRowValues", itemRowValues);
    // ----- ITEM VALIDATION -----
    const validItems = itemRowValues.filter((item) => {
      if (!item) return false;
      // when creditID is undefined
      if (item.creditID !== undefined) {
        return item._id;
      }
      // when creditID exists
      return item.itemID;
    });
    // const validItems = itemRowValues.filter(
    //   item => item?.itemID
    // );
    console.log("validItems", validItems);

    if (!validItems.length) {
      if (CreditID) {
        navigate(`/items/addItems?new=credit&id=${CreditID}`);
      } else {
        showResMsg("Please select at least 1 Item", 2000, false);
      }
      return;
    }
    console.log("hmng", validItems);
    const allRowsFilled = validItems.every((row) =>
      CreditID
        ? row.itemPrice && row.itemQuantity && row.categoryCodeName
        : row.itemID &&
          row.itemPrice &&
          row.itemQuantity &&
          row.categoryCodeName
    );
    console.log("allRowsFilled", allRowsFilled);
    if (!allRowsFilled) {
      return showResMsg(identifyMissingItems(validItems), 2000, false);
    }

    if (validItems.some((item) => !Number.isFinite(Number(item.itemPrice)) || Number(item.itemPrice) < 0 || !Number.isFinite(Number(item.itemQuantity)) || Number(item.itemQuantity) <= 0)) {
      return showResMsg("Each item needs a valid price and a positive quantity", 2000, false);
    }
    const { items, ...totals } = calculateInvoiceTotals(validItems, updatedValues.gstType);
    Object.assign(updatedValues, totals, { itemsList: items });

    // ----- CREDIT NUMBER (ONLY UPDATE MODE) -----
    if (CreditID) {
      validateField(updatedValues.creditNumber, setInvoiceNoErr);
    }

    // ----- CLEANUP -----
    delete updatedValues.lists;
    updatedValues.currencyValue = currencyCode;

    // ----- API CALL -----
    savingRef.current = true; setSaving(true); setSavingAction(draft ? "draft" : "issue");
    try { await handleApiResponse({
      isUpdate: Boolean(CreditID),
      values: updatedValues,
      setOpen,
      showResMsg,
      navigate,
      handleSoftDismisal,
      setShowBillingModal,
      dispatch,
      redirectToOutside,
      CreditID,
    }); } finally { savingRef.current = false; setSaving(false); setSavingAction(""); }
  };

  // const handleSaveInvoice = async (redirectToOutside = null) => {

  //   type && (values.type = type);
  //   clearAllErrorMsg();
  //   let mandateFlag = false;

  //   let creditDate = new Date(values.creditDate);
  //   creditDate.setUTCHours(0, 0, 0, 0);

  //   let dueDate = new Date(values.dueDate);
  //   dueDate.setUTCHours(23, 59, 59, 999);

  //   if (dueDate <= creditDate) {
  //     return showResMsg("Due date should be more than credit date", 2000, false);
  //   }

  //   if (values.contactID === '') {
  //     mandateFlag = validateField(values.contactID, setContactNameErr) || mandateFlag;
  //     // showResMsg("Please select Contact Name", 2000, false);
  //     return;
  //   }

  //   values.creditID = CreditID ? CreditID : values.creditID;

  //   if (CreditID) {

  //     mandateFlag = validateField(values.creditNumber, setInvoiceNoErr) || mandateFlag;
  //     console.log("itemRowValues", itemRowValues)
  //     const filterItemList = itemRowValues.filter(item => item._id !== "" && item._id !== null && item._id !== undefined);

  //     console.log("filterItemList1", filterItemList)
  //     if (filterItemList.length > 0) {
  //       const allRowsFilled = filterItemList.every(row => row._id && row.itemPrice && row.itemQuantity && row.categoryCodeName);
  //       console.log("allRowsFilled", allRowsFilled)
  //       if (allRowsFilled) {
  //         values.itemsList = filterItemList;
  //       } else {
  //         return showResMsg(identifyMissingItems(filterItemList), 2000, false);
  //       }

  //     } else {
  //       navigate(`/items/addItems?new=invoice&id=${CreditID}`);
  //       return;

  //     }

  //   } else {
  //     const filterItemList = itemRowValues.filter(item => item._id !== "" && item._id !== null && item._id !== undefined);
  //     console.log("filterItemList2", filterItemList)
  //     if (filterItemList.length > 0) {
  //       const allRowsFilled = filterItemList.every(row => row.itemID && row.itemPrice && row.itemQuantity && row.categoryCodeName);
  //       if (allRowsFilled) {
  //         values.itemsList = filterItemList;
  //       } else {
  //         return showResMsg(identifyMissingItems(filterItemList), 2000, false);
  //       }
  //     } else {
  //       // if (redirectToOutside !== 'redirectToItemWhenSave') {
  //       showResMsg("Please select at least 1 Item", 2000, false);
  //       // return;
  //       // }
  //     }

  //   }

  //   delete values.lists;
  //   if (mandateFlag) return
  //   values.currencyValue = currencyCode;
  //   console.log("values before api call", values)

  //   handleApiResponse({
  //     isUpdate: CreditID !== undefined,
  //     values,
  //     setOpen,
  //     showResMsg,
  //     navigate,
  //     handleSoftDismisal,
  //     setShowBillingModal,
  //     dispatch,
  //     redirectToOutside: redirectToOutside,
  //     CreditID,
  //     // redirectToOutside: (CreditID !== undefined),
  //   });

  // }
  const handleSoftDismisal = () => {
    ShowSwalWithButtons(
      `The Reference number already exists`,
      "Do you wish to continue?",
      "warning",
      darkMode,
      () => {
        values.skip_PO_NO = true;
        handleSaveInvoice();
      }
    );
  };

  const handleAddNewItem = async () => {
    if (typeQuotation && !CreditID) {
      return; // Exit the function early without doing anything
    }

    console.log("redirectToOutside");
    await handleSaveInvoice("redirectToItemWhenSave");
  };
  //Handles Item Rows Functions
  const handleRemove = (index) => {
    ShowSwalWithButtons(
      "Are you sure?",
      `Would you like to remove the Item?`,
      "warning",
      darkMode,
      () => {
        if (itemRowValues.length > 1) {
          const list = [...itemRowValues];
          list.splice(index, 1);
          setItemRowValues(list);
        } else {
          setItemRowValues([
            {
              itemName: "",
              itemID: "",
              itemPrice: "",
              itemQuantity: "",
              itemDescription: "",
              categoryCodeName: "",
              gst: "",
              discountType: "None",
              discountValue: "",
              discountAmount: 0,
              totalItemPrice: 0,
            },
          ]);
        }
      }
    );
  };
  const handleEdit = (index) => {
    ShowSwalWithButtons(
      "Are you sure?",
      "Would you like to Edit the Item?",
      "warning",
      darkMode,
      () => {
        if (CreditID) {
          navigate(
            `/items/editItem/${itemRowValues[index].itemID}?source=credit&id=${
              CreditID || ""
            }`
          );
        } else {
          navigate(`/items/editItem/${itemRowValues[index].itemID}?new=credit`);
        }
      }
    );
  };

  const handleCancel = (index) => {
    ShowSwalWithButtons(
      "Are you sure?",

      `Would you like to exit from this ${
        CreditID ? "Edit Credit Note" : "Add New Credit Note"
      }?`,
      "warning",
      darkMode,
      () => {
        navigate(routePath); // ✅ redirect user
      }
    );
  };

  const handleCalculation = (gstType, rows = itemRowValues) => {
    const { items, ...totals } = calculateInvoiceTotals(rows, gstType || "Inclusive");
    setItemRowValues((previous) => JSON.stringify(items) === JSON.stringify(previous) ? previous : items);
    setValues((previous) => ({ ...previous, gstType: gstType || "Inclusive", ...totals }));
  };
  const calculateDiscountAmount = (rows) => handleCalculation(values.gstType, rows);
  useEffect(() => {
    handleCalculation(values.gstType);
  }, [values.gstType]);

  const handleItemRowChange = async (name, value, index) => {
    if (["itemPrice", "itemQuantity", "discountValue"].includes(name) && value !== "" && !/^\d{0,7}(?:\.\d{0,2})?$/.test(String(value))) return;
    const rows = itemRowValues.map((row, rowIndex) => rowIndex === index
      ? { ...row, [name]: value, ...(name === "discountType" && value === "None" ? { discountValue: 0 } : {}) }
      : row);
    handleCalculation(values.gstType, rows);
  };

  const handleItemDescription = async (name, value, index) => {
    const updatedRows = [...itemRowValues];
    updatedRows[index] = { ...updatedRows[index], [name]: value };
    setItemRowValues(updatedRows);
  };

  const handleItemRow = async (name, newValue, index) => {
    console.log("dataaas", index, name, newValue);
    if (!newValue) {
      showResMsg("Please select an item", 1000, false);
      return;
    }
    if (newValue.value === "add-new") {
      handleAddNewItem();
    } else {
      const selectedItem = masterItemDetails.find(
        (item) => item._id === newValue.value
      );
      if (selectedItem) {
        const updatedRows = [...itemRowValues];
        updatedRows[index] = {
          ...updatedRows[index],
          itemID: newValue.value,
          itemName: selectedItem.itemName,
          itemDescription: selectedItem.itemDescription,
          categoryCodeName: selectedItem.categoryCodeName,
          itemPrice: parseFloat(selectedItem.itemPrice),
          itemQuantity: Number(selectedItem.itemQuantity) > 0 ? Number(selectedItem.itemQuantity) : 1,
          totalItemPrice:
            parseFloat(selectedItem.itemPrice).toFixed(2) *
            (Number(selectedItem.itemQuantity) > 0 ? Number(selectedItem.itemQuantity) : 1),
          gst: parseFloat(selectedItem.gst),
          discountType: selectedItem.discountType,
          discountValue: Number(selectedItem.discountValue || 0),
          discountAmount:
            selectedItem.discountType === "Fixed"
              ? selectedItem.discountValue
              : 0,
        };
        handleCalculation(values.gstType, updatedRows);
      }
    }
  };

  useEffect(() => {
    const itemFromUrl = new URLSearchParams(window.location.search).get("item");
    if (itemFromUrl) {
      const selectedItem = masterItemDetails.find(
        (item) => item._id === itemFromUrl
      );
      console.log("selectedItem", selectedItem);
      if (selectedItem) {
        const newItemValue = { value: itemFromUrl };

        // Find the first empty row (if any)
        const emptyRowIndex = itemRowValues.findIndex(
          (row) => !row.value && row.value !== undefined && row.value !== null
        );
        console.log("Emptyhj", emptyRowIndex);
        if (emptyRowIndex !== -1) {
          // Update the first empty row found
          console.log("Emptyhj", emptyRowIndex);

          handleItemRow("", newItemValue, emptyRowIndex);
        } else {
          // If no empty row is found, update the last row or add new row logic
          const lastIndex = itemRowValues.length - 1;
          console.log("itemslist", lastIndex);
          handleItemRow("", newItemValue, lastIndex);

          console.warn("No empty row found, updating the last row instead");
        }
      }
    }
    if (
      JSON.stringify(retentionItemValues) !==
      JSON.stringify(retentionItemValuesRef.current)
    ) {
      retentionItemValuesRef.current = retentionItemValues;
      const sum = retentionItemValues.reduce(
        (acc, curr) =>
          parseFloat(acc) + parseFloat(curr.retentionPaymentAmount || 0),
        0
      );
      setUsedRetentionAmount(sum);
    }
  }, [retentionItemValues, masterItemDetails]);

  const filteredOptions = itemsDetails.map((item) => ({
    label: item.itemName,
    value: item._id,
  }));

  const coloredShadowChange = document.querySelectorAll(".dayHour");
  if (coloredShadowChange) {
    for (let i = 0; i < coloredShadowChange.length; i++) {
      coloredShadowChange[i].style.color = darkMode ? "white" : "black";
    }
  }

  let columns = [
    {
      name: <p style={{ fontSize: "12px" }}>Item Name</p>,
      selector: (row, i) => (
        <Autocomplete
          disableClearable
          key={`${i}-${row.itemID}`}
          id={`item-${i}`}
          sx={{
            "& .MuiInputBase-root": {
              width: "170px",
            },
          }}
          options={[...filteredOptions]}
          // options={[{ label: "Add New Item", value: "add-new" }, ...filteredOptions]}
          onChange={(event, newValue) => handleItemRow("itemID", newValue, i)}
          value={row.itemName}
          isOptionEqualToValue={(option, value) => option.label === value}
          renderInput={(params) => (
            <TextField
              {...params}
              autoFocus
              variant="standard"
              placeholder="Search for an Item"
              size="medium"
              // sx={{ color: darkMode ? "white" : "black", }}
              sx={{
                "& .MuiInput-root": {
                  height: "35.11px",
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              inputProps={{
                ...params.inputProps,
                maxLength: 200, // ⭐ Max length applied
              }}
            />
          )}
          renderOption={(props, option) => {
            const customStyle =
              option.value === "add-new"
                ? darkMode
                  ? tableBorder
                  : tableBorder
                : darkMode
                ? "autoCompleteDarkList"
                : "autoCompleteList";

            return (
              <li
                {...props}
                key={option.value}
                style={{
                  fontSize: "12px",
                  color: darkMode ? tableBorder : tableBorder,
                  padding: "4.8px 16px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                  cursor: "pointer",
                }}
                className={customStyle}
              >
                {option.label}
              </li>
            );
          }}
          filterOptions={(options, state) => {
            const filtered = options.filter((option) =>
              option.label
                .toLowerCase()
                .includes(state.inputValue.toLowerCase())
            );
            // if (!filtered.some(option => option.value === 'add-new')) {
            //   filtered.unshift({ label: "Add New Item", value: "add-new" });
            // }
            return filtered;
          }}
        />
      ),
      style: {
        justifyContent: "flex-start",
      },
      width: "170px",
      marginTop: "4px",
    },
    {
      name: <p style={{ fontSize: "12px" }}>Description</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              value={row.itemDescription}
              onChange={(event) =>
                handleItemDescription("itemDescription", event.target.value, i)
              }
              autoComplete="off"
              className="removeExtraPadding"
              id="standard-textarea"
              placeholder="Description"
              multiline
              variant="standard"
              sx={{
                "& .MuiInputBase-root": {
                  width: "320px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              InputProps={{
                style: {
                  fontSize: "12px",
                  whiteSpace: "pre-wrap",
                  overflowWrap: "break-word",
                  width: "100%",
                  minWidth: "300px",
                  color: darkMode ? "white" : "black",
                  boxSizing: "border-box",
                  display: "block",
                },
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
      width: "360px",
    },
    {
      name: <p style={{ fontSize: "12px" }}>Qty</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              autoComplete="off"
              type="text"
              className="removeExtraPadding "
              fullWidth
              onInput={(e) =>
                (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))
              }
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              variant="standard"
              value={row.itemQuantity}
              onChange={(event) =>
                handleItemRowChange("itemQuantity", event.target.value, i)
              }
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Item Price</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={row.itemPrice}
              // value={formatCurrencyAUD(row.itemPrice)}
              variant="standard"
              onInput={(e) =>
                (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))
              }
              onChange={(event) =>
                handleItemRowChange("itemPrice", event.target.value, i)
              }
              fullWidth
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              inputProps={{
                maxLength: 8,
                pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Amount</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={formatCurrencyAUD(row.totalItemPrice)}
              variant="standard"
              onChange={(event) =>
                handleItemRowChange("totalItemPrice", event.target.value, i)
              }
              fullWidth
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              disabled
              inputProps={{
                maxLength: 8,
                pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Account</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              disabled
              type="text"
              value={row.categoryCodeName}
              variant="standard"
              onChange={(event) =>
                handleItemRowChange("categoryCodeName", event.target.value, i)
              }
              fullWidth
              className="dayHour"
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
      width: "200px",
    },

    {
      name: <p style={{ fontSize: "12px" }}>GST (%)</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              autoComplete="off"
              variant="standard"
              fullWidth
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              value={row.gst}
              onChange={(event) =>
                handleItemRowChange("gst", event.target.value, i)
              }
              disabled
              style={{ cursor: "default", pointerEvents: "none" }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },
    // {
    //   name: <p style={{ fontSize: "12px" }}>Discount Type</p>,

    //   selector: (row, i) => (
    //     <Grid container spacing={1}>
    //       <Grid item xs={12}>
    //         <FormControl fullWidth variant="standard" sx={{ m: 1, mt: 0, ml: -1.5 }}>
    //           <Select
    //             style={{ height: "35.11px", marginTop: "1.5px" }}
    //             labelId="day-hours-select-label"
    //             id="day-hours-select"
    //             className="dayHour"
    //             value={row.discountType}
    //             onChange={(event) => handleItemRowChange("discountType", event.target.value, i)}
    //             fullWidth
    //             sx={{
    //               width: "100px"
    //               ,
    //               color: darkMode ? "white" : "black",
    //               '& .MuiInputBase-root ': {

    //               },
    //               '&:before': {
    //                 borderBottomColor: darkMode ? "white" : tableBorder,
    //               },
    //               '&:hover:not(.Mui-disabled):before': {
    //                 borderBottomColor: darkMode ? "white" : tableBorder
    //               },
    //               '&:after': {
    //                 borderBottomColor: darkMode ? tableBorder : tableBorder,
    //               },
    //               '& .MuiSelect-select': {
    //                 color: darkMode ? "white" : "black",
    //               },
    //             }}
    //             variant="standard"
    //           >
    //             <MenuItem value="None">None</MenuItem>
    //             <MenuItem value="Percentage">Percentage</MenuItem>
    //             <MenuItem value="Fixed">Fixed</MenuItem>
    //           </Select>
    //         </FormControl>
    //       </Grid>
    //     </Grid>
    //   ),
    //   style: {
    //     justifyContent: 'flex-start',
    //   },
    //   width: '140px',
    // },
    // {
    //   name: <p style={{ fontSize: "12px" }}>Discount Value</p>,

    //   selector: (row, i) => (
    //     <Grid container spacing={1}>
    //       <Grid item xs={12}>
    //         <TextField
    //           type="text"
    //           autoComplete="off"
    //           variant="standard"
    //           fullWidth
    //           sx={{
    //             color: darkMode ? "white" : "black",
    //             '& .MuiInputBase-input ': {

    //               marginTop: "4px"
    //             },
    //             "& .MuiInput-root": {
    //               color: " #000000",
    //               fontFamily: "Roboto",
    //               "&:before": {
    //                 borderColor: darkMode ? "white" : tableBorder,
    //               },
    //               "&:after": {
    //                 borderColor: darkMode ? tableBorder : tableBorder,
    //               },
    //             },
    //           }}
    //           disabled={row.discountType === "None"}
    //           value={row.discountType === "None" ? 0 : row.discountValue}
    //           onChange={(event) => handleItemRowChange("discountValue", event.target.value, i)}
    //           inputProps={{
    //             maxLength: 30,
    //             pattern: "^[a-zA-Z0-9 ]+$",
    //           }}
    //         />
    //       </Grid>
    //     </Grid>
    //   ),
    //   style: {
    //     justifyContent: 'flex-start',
    //   },

    // },

    {
      // name: "Action",
      name: <p></p>,
      selector: (row) => row._id,
      cell: (row, i) => (
        <>
          <Grid
            container
            style={{ display: "flex", justifyContent: "center" }}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item>
              {row.itemID ? (
                <TimelineItem
                  color="error"
                  icon="delete"
                  onClick={() => {
                    handleRemove(i);
                  }}
                  title="Delete"
                />
              ) : (
                <TimelineItem color="gray" icon="delete" title="Delete" />
              )}
            </Grid>
            <Grid item>
              {row.itemID ? (
                <TimelineItem
                  color="success"
                  icon="edit"
                  onClick={() => {
                    handleEdit(i);
                  }}
                  title="Edit"
                />
              ) : (
                <TimelineItem color="gray" icon="edit" title="Edit" />
              )}
            </Grid>
          </Grid>
        </>
      ),
    },
  ];

  let quotationReadOnlyColumns = [
    {
      name: <p style={{ fontSize: "12px" }}>Item Name</p>,
      selector: (row, i) => (
        <Autocomplete
          disableClearable
          key={`${i}-${row.itemID}`}
          id={`item-${i}`}
          sx={{
            "& .MuiInputBase-root": {
              width: "170px",
            },
          }}
          options={[
            { label: "Add New Item", value: "add-new" },
            ...filteredOptions,
          ]}
          onChange={(event, newValue) => handleItemRow("itemID", newValue, i)}
          value={row.itemName}
          isOptionEqualToValue={(option, value) => option.label === value}
          renderInput={(params) => (
            <TextField
              {...params}
              autoFocus
              disabled
              variant="standard"
              placeholder="Search for an Item"
              size="medium"
              // sx={{ color: darkMode ? "white" : "black", }}
              sx={{
                "& .MuiInput-root": {
                  height: "35.11px",
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
            />
          )}
          renderOption={(props, option) => {
            // const customStyle = option.value === 'add-new' ? 'dropDownDefaultHighlight' : darkMode ? 'autoCompleteDarkList' : 'autoCompleteList';
            const customStyle =
              option.value === "add-new"
                ? darkMode
                  ? tableBorder
                  : tableBorder
                : darkMode
                ? "autoCompleteDarkList"
                : "autoCompleteList";
            return (
              <li
                {...props}
                key={option.value}
                style={{
                  fontSize: "12px",
                  color: darkMode ? tableBorder : tableBorder,
                  padding: "4.8px 16px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                  cursor: "pointer",
                }}
                disabled={typeQuotation && !CreditID}
                className={customStyle}
              >
                {option.label}
              </li>
            );
          }}
          filterOptions={(options, state) => {
            const filtered = options.filter((option) =>
              option.label
                .toLowerCase()
                .includes(state.inputValue.toLowerCase())
            );

            if (!filtered.some((option) => option.value === "add-new")) {
              filtered.unshift({ label: "Add New Item", value: "add-new" });
            }
            return filtered;
          }}
        />
      ),
      style: {
        justifyContent: "flex-start",
      },
      width: "170px",
      marginTop: "4px",
    },
    {
      name: <p style={{ fontSize: "12px" }}>Description</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              value={row.itemDescription}
              onChange={(event) =>
                handleItemDescription("itemDescription", event.target.value, i)
              }
              autoComplete="off"
              className="removeExtraPadding"
              id="standard-textarea"
              placeholder="Description"
              multiline
              disabled
              variant="standard"
              sx={{
                "& .MuiInputBase-root": {
                  width: "320px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              InputProps={{
                style: {
                  fontSize: "12px",
                  whiteSpace: "pre-wrap",
                  overflowWrap: "break-word",
                  width: "100%",
                  minWidth: "300px",
                  color: darkMode ? "white" : "black",
                  boxSizing: "border-box",
                  display: "block",
                },
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
      width: "360px",
    },
    {
      name: <p style={{ fontSize: "12px" }}>Qty</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              autoComplete="off"
              type="text"
              className="removeExtraPadding "
              fullWidth
              disabled
              onInput={(e) =>
                (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))
              }
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              variant="standard"
              value={row.itemQuantity}
              onChange={(event) =>
                handleItemRowChange("itemQuantity", event.target.value, i)
              }
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Item Price</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={row.itemPrice}
              variant="standard"
              onInput={(e) =>
                (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))
              }
              onChange={(event) =>
                handleItemRowChange("itemPrice", event.target.value, i)
              }
              fullWidth
              disabled
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              inputProps={{
                maxLength: 8,
                pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Amount</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={row.totalItemPrice}
              variant="standard"
              disabled
              onChange={(event) =>
                handleItemRowChange("totalItemPrice", event.target.value, i)
              }
              fullWidth
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              inputProps={{
                maxLength: 8,
                pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Account</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              disabled
              type="text"
              value={row.categoryCodeName}
              variant="standard"
              onChange={(event) =>
                handleItemRowChange("categoryCodeName", event.target.value, i)
              }
              fullWidth
              className="dayHour"
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
      width: "200px",
    },

    {
      name: <p style={{ fontSize: "12px" }}>GST (%)</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              autoComplete="off"
              variant="standard"
              fullWidth
              disabled
              sx={{
                "& .MuiInputBase-input ": {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              value={row.gst}
              onChange={(event) =>
                handleItemRowChange("gst", event.target.value, i)
              }
              style={{ cursor: "default", pointerEvents: "none" }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: "flex-start",
      },
    },
  ];

  const [fileError, setFileError] = useState("");
  //Quotation Document Functions
  const saveFile = async (event) => {
    const file = event.target.files[0];
    console.log("file", file);
    const fileNameWithoutExtension = file.name
      .split(".")
      .slice(0, -1)
      .join(".");
    console.log("fileName", fileNameWithoutExtension);
    setValues((prev) => ({
      ...prev,
      documentName: fileNameWithoutExtension,
    }));

    if (file && file.type) {
      if (file.size > 1 * 1024 * 1024) {
        setFileError("File size should be less than 1 MB");
        return;
      } else {
        document.getElementById("invoiceDocuments").value = file.name;
        setFileError("");
        console.log("values.documentName", values.documentName);
        if (file.name) {
          try {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("creditID", values.creditID);
            formData.append("documentName", fileNameWithoutExtension);
            formData.append("fileType", await getFileType(file.type));
            values.selectedID &&
              formData.append("documentID", values.selectedID);
            setLoading(true);
            await axios
              .post(
                appConstants.baseURL + "invoice/uploadInvoiceDocument",
                formData,
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
                  },
                }
              )
              .then((res) => {
                let response = res.data;
                setLoading(false);
                showResMsg(
                  response.Result_Message,
                  2000,
                  response.Result_Status
                );
                if (response.Result_Status) {
                  setValues({ ...values, documentName: "", selectedID: "" });
                  setDocuments(response.Result_Output);
                  document.getElementById("invoiceDocuments").value = "";
                }
              });
          } catch (error) {
            console.log("error addDocument", error);
          }
        } else {
          setFileError("Please enter Document Name");
        }
      }
    } else {
      console.log("No file selected or file object is false/undefined");
      showResMsg("Please select a valid file!", 2000, false);
      setFileError("");
    }
  };

  const handleEditDocument = (selectedDocRow) => {
    ShowSwalWithButtons(
      "Are you sure?",
      `Would you like to edit "${selectedDocRow.documentName}" file?`,
      "warning",
      darkMode,
      () => {
        setValues({
          ...values,
          documentName: selectedDocRow.documentName,
          selectedID: selectedDocRow._id,
        });
      }
    );
    // Swal.fire({
    //   title: 'Are you sure?',
    //   text: `Would you like to edit "${selectedDocRow.documentName}" file?`,
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonColor: "#4CAF50",
    //   cancelButtonColor: "#6c757d",
    //   confirmButtonText: "Yes",
    //   cancelButtonText: "No",
    //   reverseButtons: true,
    //   customClass: {
    //     title: darkMode ? "swal-title-dark" : "swal-title-light",
    //     popup: darkMode ? "darkPopup" : "whitePopup",
    //   },
    //   allowEnterKey: false, allowOutsideClick: false, allowEscapeKey: false,
    // })
    //   .then(async (value) => {
    //     if (value.isConfirmed) {
    //       setValues({ ...values, documentName: selectedDocRow.documentName, selectedID: selectedDocRow._id });
    //     }
    //   });
  };

  const handleDeleteDocument = async (selectedDocRow) => {
    ShowSwalWithButtons(
      "Are you sure?",
      `Would you like to delete "${selectedDocRow.documentName}" file?`,
      "warning",
      darkMode,
      () => {
        axios
          .post(
            appConstants.baseURL + "invoice/deleteInvoiceDocument",
            { documentID: selectedDocRow._id },
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
              },
            }
          )
          .then((res) => {
            if (res.data.Result_Status) {
              showResMsg(
                genericMessage.documentDeleted,
                1000,
                res.data.Result_Status
              );

              const updatedQuoDocument = quoDocuments.filter((item) => {
                return item.documentName !== selectedDocRow.documentName;
              });
              setDocuments(updatedQuoDocument);
            } else {
              showResMsg(res.data.Result_Message, 2000, false);
            }
          })
          .catch((error) => {
            console.log("deleteQuotationDocument error", error.message);
          });
      }
    );
    // Swal.fire({
    //   title: 'Are you sure?',
    //   text: `Would you like to delete "${selectedDocRow.documentName}" file?`,
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonColor: "#4CAF50",
    //   cancelButtonColor: "#6c757d",
    //   confirmButtonText: "Yes",
    //   cancelButtonText: "No",
    //   reverseButtons: true,
    //   allowEnterKey: false, allowOutsideClick: false, allowEscapeKey: false,
    //   customClass: {
    //     popup: darkMode ? 'darkPopup' : 'whitePopup',
    //   },
    // }).then(async (value) => {
    //   if (value.isConfirmed) {
    //     await axios.post(appConstants.baseURL + "invoice/deleteInvoiceDocument", { documentID: selectedDocRow._id }, {
    //       headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` }
    //     }).then(
    //       res => {
    //         if (res.data.Result_Status) {
    //           showResMsg(genericMessage.documentDeleted, 1000, res.data.Result_Status);

    //           const updatedQuoDocument = quoDocuments.filter(item => {
    //             return item.documentName !== selectedDocRow.documentName;
    //           });
    //           setDocuments(updatedQuoDocument);
    //         } else {
    //           showResMsg(res.data.Result_Message, 2000, false);
    //         }
    //       }).catch(error => {
    //         console.log("deleteQuotationDocument error", error.message);
    //       })
    //   }
    // });
  };

  const documentColumns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,
      sortable: true,
      sortField: "name",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Action(s)",
      selector: (row) => row,
      center: "true",
      cell: (row) => (
        <>
          <Grid
            container
            justifyContent={"center"}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item>
              {row.fileType === "docx" ||
              row.fileType === "doc" ||
              row.fileType === "excel" ? (
                <a
                  className="testing"
                  href={
                    appConstants.baseURL +
                    "quotation/viewUploadedQuotationDocument?fileName=/" +
                    row.documentFileName
                  }
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TimelineItem
                    color="info"
                    icon="visibility"
                    onClick={() => {
                      renderFilePreview(row);
                    }}
                    title="View"
                    // disabled={SCREEN_RIGHT === "View Only"}
                  />
                </a>
              ) : (
                <TimelineItem
                  color="info"
                  icon="visibility"
                  onClick={() => {
                    handleViewDocument(row);
                  }}
                  title="View"
                  // disabled={SCREEN_RIGHT === "View Only"}
                />
              )}
            </Grid>
            {CreditID && (
              <Grid item>
                <TimelineItem
                  color="error"
                  icon="delete"
                  onClick={() => handleDeleteDocument(row)}
                  title="Delete"
                  disabled={SCREEN_RIGHT === "View Only"}
                />
              </Grid>
            )}
          </Grid>
        </>
      ),
    },
  ];

  const handleDateChange = async (date) => {
    values.creditDate = await formatDateWithCurrentTimeForPickDate(date);
    setValues({ ...values, creditDate: values.creditDate });
  };

  const handleDueDateChange = async (date) => {
    values.dueDate = await formatDateWithCurrentTimeForPickDate(date);
    setValues({ ...values, dueDate: values.dueDate });
  };

  const addNewRetentionRow = () => {
    const allRowsFilled = retentionItemValues.every(
      (row) => row.retentionPaymentAmount && row.retentionDueDate
    );
    if (allRowsFilled) {
      if (parseFloat(usedRetentionAmount) < parseFloat(values.finalAmount)) {
        const InvoiceDueDate = new Date(values.dueDate).toLocaleDateString();
        retentionItemValues.some((element, index) => {
          const retentionDueDate = new Date(
            element.retentionDueDate
          ).toLocaleDateString();
          if (retentionDueDate > InvoiceDueDate) {
            setLoading(true);
            setTimeout(async () => {
              showResMsg(
                `Retention Due Date on ${values.invoiceNumber}/R${
                  index + 1
                } can't be more than Invoice Due Date`,
                2000,
                false
              );
              setLoading(false);
            }, 2000);

            return true;
          }
          return false;
        });

        setRetentionItemValues([
          ...retentionItemValues,
          {
            retentionPaymentAmount: "",
            retentionNumber: `${values.invoiceNumber}/R${
              retentionItemValues.length + 1
            }`,
            retentionDueDate: new Date(
              new Date() - new Date().getTimezoneOffset() * 60000
            ),
          },
        ]);
      } else {
        setLoading(true);
        setTimeout(async () => {
          showResMsg(
            `Unable to add row for Retention as Retention limit has been reached.`,
            2000,
            false
          );
          setLoading(false);
        }, 2000);
      }
    } else {
      showResMsg(
        "Please fill in all Fields values before adding a new row for retention.",
        2000,
        false
      );
    }
  };

  const handleRemoveRetention = (index) => {
    if (retentionItemValues.length >= 1) {
      ShowSwalWithButtons(
        "Are you sure?",
        `Would you like to remove this Retention?`,
        "warning",
        darkMode,
        () => {
          const list = [...retentionItemValues];
          list.splice(index, 1);
          list.forEach((element) => {
            element.retentionNumber = `${values.invoiceNumber}/R${
              list.indexOf(element) + 1
            }`;
          });
          setRetentionItemValues(list);
          if (list.length === 0) {
            setScheduleRetention(false);
          }
        }
      );
    }
  };
  const isValidDate = (date) => {
    return date instanceof Date && !isNaN(date);
  };
  let columnRetention = [
    {
      name: "Retention No.",
      selector: (row, i) => (
        <TextField
          type="text"
          value={row.retentionNumber}
          variant="outlined"
          fullWidth
          disabled
        />
      ),
      style: {
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
        display: "block",
      },
    },
    {
      name: `Payment Amount (${currencyCode})`,
      selector: (row, i) => (
        <TextField
          type="text"
          value={formatCurrencyAUD(row.retentionPaymentAmount)}
          variant="outlined"
          onChange={(event) =>
            handleRetentionRowChange(
              "retentionPaymentAmount",
              event.target.value,
              i
            )
          }
          autoFocus
          fullWidth
          disabled={row.retentionStatus === "Paid"}
          autoComplete="off"
          inputProps={{
            maxLength: 8,
            pattern: "[]",
          }}
        />
      ),
      center: "true",
      style: {
        paddingLeft: "20px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      },
    },

    {
      name: "Retention Due Date",
      selector: (row, i) => (
        <PickDate
          size="sm"
          disabled={row.retentionStatus === "Paid"}
          selected={
            isValidDate(new Date(row.retentionDueDate))
              ? new Date(row.retentionDueDate)
              : new Date()
          }
          onChange={(date) =>
            handleRetentionRowChange("retentionDueDate", date, i)
          }
          dateFormat="MMM d, yyyy"
          minDate={new Date(values.creditDate)}
          maxDate={new Date(values.dueDate)}
        />
      ),
      center: "true",
      style: {
        paddingLeft: "20px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      },
    },

    {
      name: "Action(s)",
      selector: (row) => row._id,
      center: "true",
      cell: (row, i) => (
        <>
          <Grid
            container
            justifyContent={"center"}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item>
              {row.retentionStatus !== "Paid" ? (
                <TimelineItem
                  color="error"
                  icon="delete"
                  onClick={() => {
                    // handleRemoveRetention(i);
                  }}
                  title="Delete Retention"
                />
              ) : (
                <TimelineItem color="grey" icon="delete" />
              )}
            </Grid>
          </Grid>
        </>
      ),
    },
  ];

  const handleRetentionRowChange = async (name, value, index) => {
    const updatedRows = [...retentionItemValues];
    if (name === "retentionPaymentAmount") {
      if (value === ".") {
        value = "0.";
      }
      const regex = /^\d{1,7}(?:\.\d{0,2})?$/;
      if (regex.test(value) || value === "") {
        if (parseFloat(value) === 0 || value === "") {
          showResMsg(
            "Retention " + (await convertToTitleCase(name)) + " can't be zero",
            2000,
            false
          );
        }
        updatedRows[index] = { ...updatedRows[index], [name]: value };
        const sum = updatedRows.reduce(
          (acc, curr) =>
            parseFloat(acc) + parseFloat(curr.retentionPaymentAmount || 0),
          0
        );

        if (parseFloat(sum) > parseFloat(values.finalAmount)) {
          setLoading(true);
          setTimeout(async () => {
            showResMsg(
              `Sum of Retention ${await convertToTitleCase(
                name
              )} can't be more than Retention Limit Amount`,
              2000,
              false
            );
            setLoading(false);
          }, 2000);
          return;
        } else {
          setRetentionItemValues(updatedRows);
        }
      }
    } else if (name === "retentionDueDate") {
      updatedRows[index] = { ...updatedRows[index], [name]: new Date(value) };
      setRetentionItemValues(updatedRows);
    }
  };

  const handleSaveAndSendToEmail = async () => {
    if (itemRowValues.every((row) => !row.itemID)) {
      showResMsg(genericMessage.noItemBeforeEmail, 2000, false);
    } else {
      ShowSwalWithButtons(
        "Are you sure?",
        `Would you like to send the Invoice ${values.invoiceNumber} via email to the Customer Email Address?`,
        "question",
        darkMode,
        () => {
          values.sendEmailFlag = true;
          handleSaveInvoice();
        }
      );
    }
  };

  const handleRedirectToPaymentScreen = () => {
    ShowSwalWithButtons(
      "Are you sure?",
      `Would you like to redirect the Invoice ${values.invoiceNumber} payment details?`,
      "warning",
      darkMode,
      () => {
        navigate("/credit/payment/" + CreditID);
      }
    );
  };

  const handleRetentionClick = () => {
    if (featureAccess) {
      setScheduleRetention(true);
      setRetentionItemValues([
        ...retentionItemValues,
        {
          retentionNumber: `${values.invoiceNumber}/R1`,
          retentionPaymentAmount: "",
          retentionDueDate: new Date(
            new Date().getTime() - new Date().getTimezoneOffset() * 60000
          ),
        },
      ]);
    } else {
      showResMsg(`${genericMessage.notAllowed}`, 2000, false);
    }
  };

  const handleViewDocument = (selectedDocRow) => {
    setSelectedFileType(selectedDocRow.fileType);
    if (
      selectedDocRow.fileType === "pdf" ||
      selectedDocRow.fileType === "image"
    ) {
      const path =
        appConstants.baseURL +
        "quotation/viewUploadedQuotationDocument?fileName=/" +
        selectedDocRow.documentFileName;
      setSetDocumentFileURL(path);
      path && setViewDocumentInModal(true);
    } else {
      showResMsg("Document type not supported.", 2000, false);
    }
  };
  const renderFilePreview = (selectedDocRow) => {
    setSetDocumentFileURL(
      appConstants.baseURL +
        "quotation/viewUploadedQuotationDocument?fileName=/" +
        selectedDocRow.documentFileName
    );
  };
  const handleCloseViewModal = () => {
    setSetDocumentFileURL("");
    setSelectedFileType("");
    setViewDocumentInModal(false);
  };

  //Modal Email Template used fxn start
  const handleEmailQuotation = async () => {
    if (AllKeysHaveValue(templateValues)) {
      setOpen(true);
    } else {
      await getEmailAndTemplateForQuotation(
        {
          screenType: templateValues.screenType,
          contactID: values.contactID,
          userID: sessionStorage.getItem("USER_ID").replaceAll('"', ""),
        },
        (data) => {
          if (data.Result_Status) {
            setTemplateValues(data.Result_Output);
            setOpen(true);
          } else {
            showResMsg("Please try again! Something went wrong");
            setOpen(false);
          }
        },
        dispatch
      );
    }
  };

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false);
  };

  const handleSend = (templateData) => {
    let payload = {
      userEmailAddress: templateData.userEmailAddress,
      customerEmailAddress: [...templateData.customerEmailAddress],
      emailTemplate: { ...templateData.emailTemplate },
      sendMeCopy: templateData.sendMeCopy,
    };
    values.sendEmailFlag = true;
    values.templateValues = payload;
    handleSaveInvoice();
  };
  //Modal Email Template used fxn ends
  useEffect(() => {
    const contactFromUrl = new URLSearchParams(window.location.search).get(
      "contact"
    );
    if (contactFromUrl) {
      if (contactFromUrl === "add-new") {
        handleChangeCustomer("name")("", {
          label: "Add New Customer",
          value: "add-new",
        });
      } else {
        const selectedContact = contactDetails.find(
          (contact) => contact._id === contactFromUrl
        );
        if (selectedContact) {
          handleChangeCustomer("name")("", {
            label: selectedContact.companyName,
            value: contactFromUrl,
          });
        }
      }
    }
  }, [contactDetails]);

  const customerOptions = [
    // ...(showAddNewCustomer ? [{ label: 'Add New Customer', value: 'add-new' }] : []),
    ...contactDetails.map((contact) => ({
      label: contact.companyName,
      value: contact._id,
    })),
  ];

  if (values) return (
    <DashboardLayout>
      <CreditNoteEditor
        creditID={CreditID}
        values={values}
        setValues={setValues}
        contacts={contactDetails}
        itemOptions={filteredOptions}
        lines={itemRowValues}
        setLines={setItemRowValues}
        currencyCode={currencyCode}
        contactNameError={contactNameErr}
        onCustomerChange={handleChangeCustomer("name")}
        onLineItemChange={handleItemRow}
        onLineValueChange={handleItemRowChange}
        onLineDescriptionChange={handleItemDescription}
        onRemoveLine={handleRemove}
        onCancel={handleCancel}
        onSave={() => handleSaveInvoice(null, false)}
        onSaveDraft={() => handleSaveInvoice(null, true)}
        saving={saving}
        savingAction={savingAction}
        darkMode={darkMode}
      />
      {showBillingModal && (
        <BillingModal
          open={showBillingModal}
          handleConfirm={() => navigate("/subscriptions")}
          handleCancel={() => setShowBillingModal(false)}
          closeModalClick={() => setShowBillingModal(false)}
          message={genericMessage.billingMsg}
          title={genericMessage.noCreditAvailableTitle}
        />
      )}
      <LoadingModal
        loading={loading}
        type="editor"
        variant="document"
        label="Loading credit note editor…"
      />
    </DashboardLayout>
  );

  return (
    <DashboardLayout>
      <div style={{ marginTop: "20px" }}>
        <Card color="primary">
          <PageTitle screenName={screenName} />
          <Grid container px={2} mt={2} spacing={2}>
            {/* contact Name Dropdown */}
            <Grid item lg={3} xs={4}>
              <Autocomplete
                id="customerName-select"
                options={customerOptions}
                // options={[
                //   { label: 'Add New Customer', value: 'add-new' },
                //   ...contactDetails.map(contact => ({ label: contact.companyName, value: contact._id }))]}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    key={option.value}
                    className={
                      darkMode
                        ? `${
                            option.value === "add-new"
                              ? "dropDownDefaultHighlight"
                              : "autoCompleteDarkList"
                          }`
                        : `${
                            option.value === "add-new"
                              ? "dropDownDefaultHighlight"
                              : "autoCompleteList"
                          }`
                    }
                  >
                    {option.label}
                  </li>
                )}
                filterOptions={(options, state) => {
                  const filtered = options.filter((option) =>
                    option.label
                      .toLowerCase()
                      .includes(state.inputValue.toLowerCase())
                  );

                  // if (
                  //   showAddNewCustomer &&
                  //   !filtered.some(option => option.value === 'add-new')
                  // ) {
                  //   filtered.unshift({ label: 'Add New Customer', value: 'add-new' });
                  // }

                  return filtered;
                }}
                // filterOptions={(options, state) => {
                //   const filtered = options.filter(option =>
                //     option.label.toLowerCase().includes(state.inputValue.toLowerCase())
                //   );
                //   if (!filtered.some(option => option.value === 'add-new')) {
                //     filtered.unshift({ label: 'Add New', value: 'add-new' }); // Ensure 'Add New' is always in the filtered list
                //   }
                //   return filtered;
                // }}

                onChange={handleChangeCustomer("name")}
                isOptionEqualToValue={(option, value) => {
                  if (value === "") {
                    return true;
                  }
                  return option.value === value;
                }}
                value={
                  (values.contactID &&
                    contactDetails.find(
                      (contact) => contact._id === values.contactID
                    )?.companyName) ||
                  (new URLSearchParams(window.location.search).get(
                    "contact"
                  ) === "add-new"
                    ? "Add New Customer"
                    : "")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="ress"
                    label="Customer"
                    autoFocus={true}
                    placeholder="Enter here"
                  />
                )}
                // disabled={values.invoiceType === "Through Quotation" || finalise}
              />

              {contactNameErr ? (
                <p style={errMsg}>Please Select Customer</p>
              ) : (
                ""
              )}
            </Grid>

            <Grid item lg={3} xs={6}>
              <PickDate
                selected={new Date(values.creditDate)}
                onChange={handleDateChange}
                label="Credit Note Date"
                variant="outlined"
                disabled
                InputLabelProps={{ shrink: true }}
                minDate={new Date()}
              />
            </Grid>
            {/* <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Due Upto</InputLabel>
                <Select
                  labelId="dueUpto-label"
                  label="Due Upto"
                  style={{ height: "35px" }}
                  onChange={handleValidUpto("dueUpto")}
                  value={values.dueUpto}
                  displayEmpty
                >
                  <MenuItem disabled value="">Select Due Upto</MenuItem>
                  {paymentTermsOptions.map((option, index) => (
                    <MenuItem key={index} value={option}>{option}</MenuItem>
                  ))}
                </Select>

              </FormControl>
            </Grid> */}
            {/* <Grid item lg={3} xs={12}>
              <PickDate
                selected={new Date(values.dueDate)}
                onChange={handleDueDateChange}
                label="Due Date"
                minDate={new Date(values.creditDate)}
              />
            </Grid> */}

            {/* Quotation Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Credit Note Number"
                variant="outlined"
                disabled
                fullWidth
                inputProps={{
                  maxLength: 12,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext",
                }}
                value={values.creditNumber}
              />
              {invoiceNoErr ? (
                <p style={errMsg}>Credit Note Number can't be blank.</p>
              ) : (
                ""
              )}
            </Grid>
            {/* Invoice Type */}
            {/* <Grid item lg={1.5} xs={3}>
              <FormControl fullWidth>
                <InputLabel id="daysHours-select-label">Invoice Type</InputLabel>
                <Select

                  labelId="daysHours-select-label"
                  id="daysHours-select"

                  style={{ height: "35.11px", }}
                  label="Invoice Type"
                  disabled={CreditID ? true : false}
                  onChange={handleChange("invoiceType")}
                  value={values.invoiceType}
                  autoFocus={true}
                >
                  <MenuItem value="Direct" >Direct</MenuItem>

                  <MenuItem value="Through Quotation" >
                    <span style={{ width: "100px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      Through Quotation
                    </span>
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid> */}

            {/* <Grid item lg={1.5} xs={3}>

              <Autocomplete
                color="info"
                id="quotation-select"
                options={quotationDetails?.length > 0 &&
                  quotationDetails.map(item => ({
                    label: item.quotationNumber,
                    id: item._id
                  }))}
                onChange={handleChangeApprovedQuotation("quotationNumber")}
                isOptionEqualToValue={(option, value) => {
                  if (value === "") { return true; }
                  return option.value === value;
                }}
                value={(values.quotationID && quotationDetails.find(item => item._id === values.quotationID)?.quotationNumber) || ""}
                renderInput={(params) => (
                  <TextField {...params} className="ress" placeholder="Quotation" label="Quotations" autoFocus={true} />
                )}
                disabled={values.invoiceType === "Direct" || CreditID}
              />
            </Grid> */}

            {/* Reference Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Reference Number / Invoice Number"
                variant="outlined"
                placeholder="Optional"
                fullWidth
                inputProps={{
                  maxLength: 50,
                  className: "custom-fieldtext",
                }}
                disabled={CreditID && finalise}
                value={values.purchaseOrderNumber}
                onChange={handleChange("purchaseOrderNumber")}
              />
            </Grid>

            {/* 
            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35.11px" }}
                  label="Status"
                  value={values.creditStatus}
                  disabled
                  onChange={handleChange('creditStatus')}
                >
                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                  <MenuItem value="Paid">Paid</MenuItem>
                </Select>
              </FormControl>
            </Grid> */}
          </Grid>

          <CardContent sx={tableCardStyle}>
            <DataTable
              theme={darkMode ? "solarized" : "light"}
              columns={columns}
              data={itemRowValues}
              customStyles={customStyles}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}
            />
          </CardContent>

          <Grid container px={2} style={{ marginTop: "10px" }} spacing={2}>
            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Base Amount (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={formatCurrencyAUD(
                  parseFloat(values.totalAmount).toFixed(2)
                )}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Total Discount (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                value={values.totalDiscountAmount}
                disabled
                onChange={handleChange("totalDiscountAmount")}
                // value={parseFloat(values.totalDiscountAmount).toFixed(2)}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">GST Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35px" }}
                  label="GST Type"
                  value={values.gstType || "Inclusive"}
                  onChange={handleChange("gstType")}
                >
                  <MenuItem value="Inclusive">Inclusive</MenuItem>
                  <MenuItem value="Exclusive">Exclusive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Total GST  (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={formatCurrencyAUD(values.totalGSTAmount)}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Final Amount (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={formatCurrencyAUD(
                  parseFloat(values.finalAmount).toFixed(2)
                )}
                // autoFocus={true}
              />
            </Grid>

            <Grid item lg={12} xs={12}>
              <TextField
                type="text"
                label="Payment Instructions"
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 100,
                  className: "custom-fieldtext",
                }}
                value={values.paymentInstruction}
                onChange={handleChange("paymentInstruction")}
                // autoFocus={true}
              />
            </Grid>
          </Grid>

          <section className="credit-attachments-section">
            <h2>Attachments</h2>
              {(!typeQuotation || CreditID) && (
                <>
                  <Grid container spacing={2} px={2} pt={2}>
                    {/* <Grid item lg={3} xs={4}>
                      <TextField
                        type="text"
                        label="Document Name"
                        placeholder="Document Name"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          maxLength: 30,
                          className: "custom-fieldtext"
                        }}
                        value={values.documentName}
                        onChange={handleChange('documentName')}
                        disabled
                      // autoFocus={true}
                      />
                    </Grid> */}
                    <Grid item xs={12} lg={4}>
                      <label htmlFor="fileInput">
                        <TextField
                          id="invoiceDocuments"
                          type="text"
                          label="Document File"
                          variant="outlined"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            readOnly: true,
                            className: "uploadfile",
                            startAdornment: (
                              <InputAdornment position="start">
                                <label className="ress" htmlFor="fileInput">
                                  <Button
                                    component="span"
                                    size="small"
                                    style={{
                                      fontSize: "14px",
                                      marginLeft: "-19px",
                                      color: `${
                                        darkMode ? "white" : tableBorder
                                      }`,
                                      textDecoration: "2px solid underline",
                                    }}
                                    // onClick={() => { !values.documentName && (showResMsg(`Please enter Document Name`, 1000, false)) }}
                                  >
                                    Choose File
                                  </Button>
                                </label>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <input
                          type="file"
                          // accept="image/*,.pdf,.docx,.doc,application/vnd.ms-excel,text/csv"
                          id="fileInput"
                          style={{ display: "none" }}
                          // disabled={!values.documentName}
                          onChange={saveFile}
                        />
                      </label>
                      <p style={errMsg}>{fileError}</p>
                    </Grid>
                  </Grid>
                </>
              )}

              {quoDocuments.length > 0 && (
                <CardContent sx={tableCardStyle}>
                  <DataTable
                    theme={darkMode ? "solarized" : "light"}
                    columns={documentColumns}
                    data={quoDocuments}
                    fixedHeaderScrollHeight="185px"
                    fixedHeader={true}
                    customStyles={customStyles}
                  />
                </CardContent>
              )}
          </section>

          {showSendEmailBtn && showInvoicePaymentLink && (
            <Grid item px={2} pt={1} xs={6} md={4} lg={3}>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#008000",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={handleRedirectToPaymentScreen}
              >
                Record Part Payment
              </span>
            </Grid>
          )}

          <Grid
            container
            mt={2}
            pb={3}
            // columnSpacing={{ xs: 2, md: 4, lg: 4 }}
            // columnSpacing={4}
            alignItems="center"
            spacing={2}
            style={{ display: "flex", justifyContent: "center" }}
            className="gridbuttons"
          >
            <Grid item xs={12} md={4} lg={1.68}>
              {/* <Link to={routePath}> */}
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                style={{ height: "40px" }}
                onClick={handleCancel}
              >
                Close
              </MDButton>
              {/* </Link> */}
            </Grid>
            <Grid item xs={12} md={4} lg={1.68}>
              <MDButton
                rel="noreferrer"
                variant="gradient"
                color="success"
                fullWidth
                style={{ height: "40px" }}
                // disabled={hideUpdateBtn ? quoDocuments.length === 0 : false}
                onClick={handleSaveInvoice}
                // disabled={SCREEN_RIGHT !== "Full Access"}
              >
                {CreditID ? (type !== "clone" ? "Update" : "Clone ") : "Save"}
              </MDButton>
            </Grid>
            {CreditID && (
              <Grid
                item
                xs={12}
                md={4}
                spacing={2}
                lg={1.68}
                style={{
                  cursor: `${showSendEmailBtn ? "pointer" : "not-allowed"}`,
                }}
              >
                <MDButton
                  rel="noreferrer"
                  variant="gradient"
                  color="info"
                  fullWidth
                  style={{ height: "40px" }}
                  disabled={!showSendEmailBtn}
                  // onClick={handleSaveAndSendToEmail}
                  onClick={handleEmailQuotation}
                  // disabled={SCREEN_RIGHT !== "Full Access"}
                >
                  Send Email
                </MDButton>
              </Grid>
            )}
          </Grid>
        </Card>
      </div>

      {viewDocumentInModal && (
        <Modal
          className="document-preview-overlay"
          open={viewDocumentInModal}
          onClose={handleCloseViewModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            "& .MuiModal-root": {
              width: "100%",
              height: "100%",
            },
          }}
        >
          <Card
            sx={
              darkMode
                ? {
                    ...pdfStyle,
                    border: "none",
                    width: { xs: "95%", sm: "90%", md: "80%" },
                    maxWidth: "1200px",
                    background: "black",
                  }
                : {
                    ...pdfStyle,
                    border: "none",
                    width: { xs: "95%", sm: "90%", md: "80%" },
                    maxWidth: "1200px",
                  }
            }
          >
            <Box>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{ fontSize: { xs: "1.5rem", sm: "1.75rem" } }}
              >
                Document Viewer
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  height: { xs: "60vh", sm: "70vh" },
                  overflow: "hidden",
                }}
              >
                {selectedFileType === "image" ? (
                  <img
                    title="Document Viewer"
                    src={getDocumentFileURL}
                    width="100%"
                    height="100%"
                    style={{
                      display: "block",
                      objectFit: "contain",
                      aspectRatio: "1/1",
                    }}
                    alt="Document Viewer"
                  />
                ) : selectedFileType === "pdf" ? (
                  <iframe
                    title="Quotation Document Viewer"
                    src={getDocumentFileURL}
                    width="100%"
                    height="650"
                    allowFullScreen
                  ></iframe>
                ) : null}
              </Box>
              <Grid
                container
                id="modal-modal-description"
                sx={{ mt: 2, justifyContent: "center" }}
              >
                <MDButton
                  color="warning"
                  className="modalButton"
                  onClick={() => {
                    setViewDocumentInModal(false);
                  }}
                  sx={{ fontSize: "1rem", padding: "0.5rem 1rem" }}
                >
                  Close
                </MDButton>
              </Grid>
            </Box>
          </Card>
        </Modal>
      )}
      {showBillingModal && (
        <BillingModal
          open={showBillingModal}
          handleConfirm={() => {
            navigate("/subscriptions");
          }}
          handleCancel={() => {
            setShowBillingModal(false);
          }}
          closeModalClick={() => {
            setShowBillingModal(false);
          }}
          message={genericMessage.billingMsg}
          title={genericMessage.noCreditAvailableTitle}
        />
      )}
      {open && (
        <EmailTemplateModal
          open={open}
          handleClose={handleClose}
          templatesData={templateValues}
          onSend={handleSend}
        />
      )}
      <LoadingModal
        loading={loading}
        type="editor"
        variant="document"
        label="Loading credit note editor…"
      />
    </DashboardLayout>
  );
}
export default memo(AddCreditNote);
